import type { IButtonStyles } from "@fluentui/react";
import { memoizeFunction, mergeStyleSets } from "@fluentui/react";

import type { AppGalleryStyles } from "@1js/acui-gallery";
import { isNextStyleEnabled } from "@1js/acui-theme";

const largePreviewGalleryHeight = 62;
const borderWidth = 1;

const galleryButtonStyles: IButtonStyles = {
  root: {
    height: largePreviewGalleryHeight - 2 * borderWidth, // Subtract top and bottom border width
    width: 76,
    boxSizing: "border-box",
    borderRadius: "unset",
  },
};

function getPreviewGalleryButtonStyles() {
  return mergeStyleSets(
    galleryButtonStyles,
    isNextStyleEnabled() && galleryButtonStylesNext
  );
}

const galleryButtonStylesNext: IButtonStyles = {
  root: {
    padding: 4,
  },
  rootCheckedHovered: {
    padding: 4,
  },
  rootHovered: {
    padding: 4,
  },
};

export const getLargePreviewGalleryStyles = memoizeFunction(
  (): Partial<AppGalleryStyles> => {
    return {
      galleryContainer: {
        root: {
          height: largePreviewGalleryHeight,
        },
      },
      galleryButtonInPreview: getPreviewGalleryButtonStyles(),
      galleryButtonInExpanded: galleryButtonStyles,
      previewExpandButton: {
        root: {
          height: largePreviewGalleryHeight - 2 * borderWidth, // Subtract top and bottom border width
          width: 16,
        },
        icon: {
          width: 8,
          height: 8,
          lineHeight: 8,
        },
      },
    };
  }
);

export const getLargePreviewGalleryStylesStacked = memoizeFunction(
  (): Partial<AppGalleryStyles> => {
    return {
      galleryButtonInPreview: {
        root: {
          maxWidth: 240,
          backgroundColor: "transparent",
          height: "30px",
          width: "148px",
        },
        flexContainer: {
          flexWrap: "row nowrap",
          justifyContent: "start",
          alignItems: "center",
          fontSize: 12,
        },
      },
      previewStackStyle: {
        inner: {
          width: 444,
        },
      },
    };
  }
);
